export default {
  主页面标题: "採購申請管理",
  申請採購按鈕: "申請採購",
  草稿: "草稿",
  审批中: "審批中",
  已驳回: "已駁回",
  已通过: "已通過",
  采购申请状态: "採購申請狀態",
  表单编号: "表單編號",
  PR编号: "PR編號",
  物料: "物料",
  供应商: "供應商",
  申请表类型: "申請表類型",
  采购类别: "採購類別",
  工厂: "工廠",
  二级采购类别: "二級採購類別",
  三级采购类别: "三級採購類別",
  采购负责人: "採購負責人",
  PO编号: "PO編號",
  采购项数: "採購項數",
  物料类别: "物料類別",
  物料编号: "物料編號",
  物料名称: "物料名稱",
  产品名称: "產品名稱",
  采购申请总金额HKD: "採購申請總金額（HKD）",
  要求完成日期: "要求完成日期",
  要求到货日期: "要求到貨日期",
  申请人: "申請人",
  申请时间: "申請時間",
  操作: "操作",
  搜索物料编号名称占位符: "請輸入物料編號/物料名稱",
  搜索供应商编号名称占位符: "請輸入供應商編號/供應商名稱",
  編輯: "編輯",
  查看: "查看",
  重新提交: "重新提交",
  删除: "刪除",
  采购申请表: "採購申請表",
  下一步: "下一步",
  采购类型: "採購類型",
  是否有物料編號: "是否有物料編號",
  申请信息: "申請資訊",
  请选择: "請選擇",
  请选择申请部门: "請選擇申請部門",
  暂存: "暫存",
  提交: "提交",
  关闭: "關閉",
  提交成功: "提交成功",
  请检查表单填写是否完整: "請檢查表單填寫是否完整",
  请先生成PR编号: "請先生成PR編號",
  订单确认: "訂單確認",
  审批通过: "審批通過",
  表单类型信息缺失无法执行审批: "表單類型資訊缺失，無法執行審批",
  未配置采购人员审核策略: "未配置對應表單類型的採購人員審核策略，無法執行審批",
  未配置财务人员初审策略: "未配置對應表單類型的財務人員初審策略，無法執行審批",
  请完善寻源结果: "請完善尋源結果",
  生成PR: "生成PR",
  确认: "確認",
  确认生成PR编号吗: "確認生成PR編號嗎？",
  寻源结果: "尋源結果",
  申请采购物品明细: "申請採購物品明細",
  采购组: "採購組",
  是否指定建议供应商: "是否指定/建議供應商",
  指定建议供应商名称: "指定/建議供應商名稱",
  指定建议供应商原因: "指定/建議供應商原因",
  是否需要合同: "是否需要合約",
  指定建议供应商相关附件: "指定/建議供應商的相關附件",
  寻源结果说明: "尋源結果說明",
  合約文件: "合約文件",
  供应商编号: "供應商編號",
  供应商名称: "供應商名稱",
  报价单: "報價單",
  继续添加: "繼續添加",
  请输入供应商名称: "請輸入供應商名稱",
  获取物料: "獲取物料",
  序号: "序號",
  添加: "添加",
  分类: "分類",
  申请数量: "申請數量",
  单位: "單位",
  每组单位: "每組單位",
  单价HKD: "單價 HKD",
  年采购均价: "年採購均價",
  申请总金额HKD: "申請總金額HKD",
  采购说明: "採購說明",
  采购原因: "採購原因",
  安全库存: "安全庫存",
  优先采购: "優先採購",
  上传附件: "上傳附件",
  固定资产信息: "固定資產資訊",
  是否创建固定资产编号: "是否創建固定資產編號",
  固定资产编号: "固定資產編號",
  预算信息: "預算資訊",
  申请人提供文件: "申請人提供文件",
  已批准预算类型: "已批准預算類型",
  项目编号: "項目編號",
  原因说明: "原因說明",
  预算金额币种: "預算金額/幣種",
  预算金额HKD: "預算金額 HKD",
  申请总金额币種: "申請總金額/幣種",
  采购委员会会议纪要文件: "採購委員會會議紀要文件",
  计划书URS配置清单第一次报价等文件: "計劃書/URS/配置清單/第一次報價等文件",
  实地考察报告用户要求符合度评估文件: "實地考察報告/用戶要求符合度評估文件",
  供应商比较总结商务标评分表: "供應商比較總結/商務標評分表",
  合并评分表: "合併評分表",
  投资分析: "投資分析",
  特别要求: "特別要求",
  是否现有生产物料: "是否現有生產物料",
  相关产品名称: "相關產品名稱",
  关联项目編號: "關聯項目編號",
  关联项目名称: "關聯項目名稱",
  供应商信息: "供應商資訊",
  数量单位: "數量/單位",
  单价币种: "單價/幣種",
  总价币种: "總價/幣種",
  备注: "備註",
  药典标准: "藥典/標準",
  指定建议的药典或质量标准如有: "指定/建議的藥典或質量標準（如有）",
  批次要求: "批次要求",
  是否指定供应商: "是否指定供應商",
  指定建议供应商COA: "指定/建議供應商COA",
  其他附件: "其他附件",
  RLD中文通用名稱: "RLD中文通用名稱",
  RLD英文通用名稱: "RLD英文通用名稱",
  RLD中文商品名称: "RLD中文商品名稱",
  RLD英文商品名称: "RLD英文商品名稱",
  请附上指定建议的RLD说明资料: "請附上指定/建議的RLD說明資料",
  上市国家或地区: "上市國家或地區",
  主要成分: "主要成分",
  规格: "規格",
  剂型: "劑型",
  包装规格: "包裝規格",
  需求数量: "需求數量",
  要求到货时间: "要求到貨時間",
  效期要求: "效期要求",
  从供应商库选择: "從供應商庫選擇",
  搜索物料: "搜尋物料",
  单价: "單價",
  单价单位: "單價單位",
  费用归属部门: "費用歸屬部門",
  成本中心: "成本中心",
  会计科目: "會計科目",
  物料组: "物料組",
  期望到货日期: "期望到貨日期",
  是否紧急采购: "是否緊急採購",
  单一: "單一",
  多个: "多個",
  指定供应商及型号: "指定供應商及型號",
  指定原因: "指定原因",
  采购物品描述: "採購物品描述",
  采购目的: "採購目的",
  请选择物料: "請選擇物料",
  请输入申请数量: "請輸入申請數量",
  请选择单位: "請選擇單位",
  请选择物料组: "請選擇物料組",
  请选择日期: "請選擇日期",
  请输入描述: "請輸入描述",
  请选择成本中心: "請選擇成本中心",
  请选择币种: "請選擇幣種",
  请选择采购组: "請選擇採購組",
  请输入关联项目編號: "請輸入關聯項目編號",
  请输入关联项目名称: "請輸入關聯項目名稱",
  请选择供应商: "請選擇供應商",
  二级物料类别: "二級物料類別",
  申请金额范围: "申請金額範圍",
  自动计算: "自動計算",
  总金额: "總金額",
  请输入固定资产編號: "請輸入固定資產編號",
  请输入寻源结果: "請輸入尋源結果",
  请输入包装规格: "請輸入包裝規格",
  请输入预算金额: "請輸入預算金額",
  请输入申请总金额: "請輸入申請總金額",
  请选择是否指定建议供应商: "請選擇是否指定/建議供應商",
  最后PO单价: "最後PO單價",
  新旧价格变动: "新舊價格變動",
  最后PO供应商編號: "最後PO供應商編號",
  最后PO供应商名称: "最後PO供應商名稱",
  最后PO币种: "最後PO幣種",
  上次PO价格数量单位: "上次PO價格數量單位",
  最后PO数量: "最後PO數量",
  现有库存: "現有庫存",
  描述: "描述",
  请选择是否现有生产物料: "請選擇是否現有生產物料",
  请选择要求完成日期: "請選擇要求完成日期",
  请选择费用归属部门: "請選擇費用歸屬部門",
  请选择会计科目: "請選擇會計科目",
  请选择是否紧急采购: "請選擇是否緊急採購",
};
